export default __webpack_public_path__ + "static/media/logo_full.c2cf4945.png";